// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var RelayEnv = require("../../../../RelayEnv.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var ReasonPromise = require("../../../../reason/ReasonPromise.bs.js");
var Utils__Promise = require("../../../../utils/Utils__Promise.bs.js");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var GeocodingQuery_graphql = require("../../../../__generated__/GeocodingQuery_graphql.bs.js");

var convertVariables = GeocodingQuery_graphql.Internal.convertVariables;

var convertResponse = GeocodingQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = GeocodingQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, GeocodingQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, GeocodingQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(GeocodingQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(GeocodingQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(GeocodingQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(GeocodingQuery_graphql.node, convertVariables);

var Query_geocodingErrorReason_decode = GeocodingQuery_graphql.Utils.geocodingErrorReason_decode;

var Query_geocodingErrorReason_fromString = GeocodingQuery_graphql.Utils.geocodingErrorReason_fromString;

var Query_propertyOwnerClientType_decode = GeocodingQuery_graphql.Utils.propertyOwnerClientType_decode;

var Query_propertyOwnerClientType_fromString = GeocodingQuery_graphql.Utils.propertyOwnerClientType_fromString;

var Query = {
  geocodingErrorReason_decode: Query_geocodingErrorReason_decode,
  geocodingErrorReason_fromString: Query_geocodingErrorReason_fromString,
  propertyOwnerClientType_decode: Query_propertyOwnerClientType_decode,
  propertyOwnerClientType_fromString: Query_propertyOwnerClientType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function queryFn(address, areaId, clientType, existingPropertyId) {
  return ReasonPromise.map(Utils__Promise.fromJsPromise(fetchPromised(RelayEnv.environment, {
                      input: {
                        address: address,
                        areaId: areaId,
                        clientType: clientType,
                        existingPropertyId: existingPropertyId
                      }
                    }, undefined, undefined)), (function (v) {
                if (v.TAG !== "Ok") {
                  return {
                          TAG: "Error",
                          _0: {
                            NAME: "REJECTED",
                            VAL: v._0
                          }
                        };
                }
                var response = v._0.validatePropertyAddress;
                if (response === undefined) {
                  return {
                          TAG: "Error",
                          _0: "EMPTY_RESPONSE"
                        };
                }
                switch (response.__typename) {
                  case "PropertyAddressValidated" :
                      var standardizedAddress = response.standardizedAddress;
                      var coordinates = response.coordinates;
                      var tmp;
                      if (standardizedAddress !== undefined) {
                        var address = standardizedAddress.address;
                        if (address !== undefined) {
                          var city = standardizedAddress.city;
                          if (city !== undefined) {
                            var state = standardizedAddress.state;
                            if (state !== undefined) {
                              var zip = standardizedAddress.zip;
                              tmp = zip !== undefined ? ({
                                    address: address,
                                    zip: zip,
                                    city: city,
                                    state: state
                                  }) : undefined;
                            } else {
                              tmp = undefined;
                            }
                          } else {
                            tmp = undefined;
                          }
                        } else {
                          tmp = undefined;
                        }
                      } else {
                        tmp = undefined;
                      }
                      return {
                              TAG: "Ok",
                              _0: {
                                NAME: "PropertyAddressValidated",
                                VAL: {
                                  displayNeighborhoods: Core__Option.getOr(response.displayNeighborhoods, []).map(function (dn) {
                                        return {
                                                __typename: dn.__typename,
                                                __id: dn.__id,
                                                id: dn.id,
                                                label: dn.label
                                              };
                                      }),
                                  coordinates: coordinates !== undefined ? ({
                                        lat: coordinates.lat,
                                        lon: coordinates.lon
                                      }) : undefined,
                                  standardizedAddress: tmp
                                }
                              }
                            };
                  case "ValidatePropertyAddressDuplicatePropertyError" :
                      return {
                              TAG: "Ok",
                              _0: {
                                NAME: "DuplicatePropertyError",
                                VAL: response.property
                              }
                            };
                  case "ValidatePropertyAddressGeocodingError" :
                      var tmp$1 = response.reason;
                      if ((tmp$1 === "POOR_GEOCODING_ACCURACY" || tmp$1 === "OUTSIDE_CHAPTER_BOUNDARIES" || tmp$1 === "INCOMPLETE_ADDRESS" || tmp$1 === "UNABLE_TO_GEOCODE") && tmp$1 === "OUTSIDE_CHAPTER_BOUNDARIES") {
                        return {
                                TAG: "Ok",
                                _0: {
                                  NAME: "GeocodingError",
                                  VAL: "OutsideChapterBoundaries"
                                }
                              };
                      } else {
                        return {
                                TAG: "Ok",
                                _0: {
                                  NAME: "GeocodingError",
                                  VAL: "UnableToGeocode"
                                }
                              };
                      }
                  case "__unselected" :
                      return {
                              TAG: "Error",
                              _0: "UNSELECTED_MEMBER"
                            };
                  
                }
              }));
}

exports.Query = Query;
exports.queryFn = queryFn;
/* use Not a pure module */
